module.exports = __webpack_public_path__ + "static/img/icon_fb_b.fa0ce654.svg";